var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnknwonProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer3_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "question-mark",
    fill: "currentColor",
    stroke: "none",
    d: " M 10.75 22.75 Q 10.75 23.75 11.55 24.5 12.35 25.2 13.5 25.2 14.7 25.2 15.5 24.5 16.25 23.75 16.25 22.75 16.25 21.7 15.5 20.95 14.7 20.25 13.5 20.25 12.35 20.25 11.55 20.95 10.75 21.7 10.75 22.75 M 19.8 6.05 Q 19 4.75 17.4 4.05 15.95 3.4 13.75 3.4 11.75 3.4 10.25 4.05 8.7 4.65 7.75 6.05 6.8 7.5 6.8 9.6 L 11.75 9.6 Q 11.75 8.8 12.05 8.25 12.3 7.8 12.75 7.45 13.35 7.2 13.75 7.2 14.3 7.2 14.8 7.45 15.2 7.7 15.4 8.2 15.65 8.7 15.65 9.4 15.65 10 15.35 10.6 15.15 11.15 14.6 11.65 L 13.4 12.75 Q 12.7 13.4 12.2 14.2 11.7 15.15 11.55 16 11.35 17.3 11.35 18.25 L 15.55 18.25 Q 15.65 17 15.9 16.35 16.2 15.65 17.05 14.85 L 18.85 13.15 Q 19.6 12.4 20.1 11.4 20.6 10.55 20.6 9.2 20.6 7.4 19.8 6.05 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "question-mark-circles",
    id: "Layer3_0_1_STROKES",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    fill: "none",
    d: " M 15 3 Q 20.15 3 23.8 6.65 27.5 10.3 27.5 15.5 27.5 20.65 23.8 24.3 20.15 28 15 28 9.8 28 6.15 24.3 2.5 20.7 2.5 15.5 2.5 10.3 6.15 6.65 9.8 3 15 3 Z M 15 8.95 Q 17.7 8.95 19.65 10.8 21.5 12.8 21.5 15.5 21.5 18.2 19.65 20.2 17.7 22.05 15 22.05 12.25 22.05 10.25 20.2 8.4 18.2 8.4 15.5 8.4 12.75 10.25 10.8 12.25 8.95 15 8.95 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_0_1_STROKES"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.9259185791015625, 0, 0, 0.9259185791015625, 1.95,2.45) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_1_FILL"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnknwonProfile);
export default __webpack_public_path__ + "static/media/icon-unknwon-profile.44eb1f39317fd95fc6f3a9409e434659.svg";
export { ForwardRef as ReactComponent };